<template>
  <div class="content">
    <p class="title">缴费状态</p>
    <div class="status">
      <div class="status-item">
        <p class="item-title">{{ isOwner === true ? '本期应缴物业数量' : '本期应缴租户数量' }}</p>
        <p class="item-number">10022</p>
      </div>
      <div class="status-item">
        <p class="item-title">{{ isOwner === true ? '本期实缴物业数量' : '本期实缴租户数量' }}</p>
        <p class="item-number">10022</p>
      </div>
      <div class="status-item">
        <p class="item-title">{{ isOwner === true ? '本期待缴物业数量' : '本期待缴租户数量' }}</p>
        <p class="item-number">10022</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paymentStatus',
  props: {
    isOwner: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  color: #333;
  .title {
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }
  .status {
    width: 100%;
    height: calc(100% - 40px);
    // border: 1px solid;
    display: flex;
    justify-content: center;
  }
  .status-item {
    margin: 0 100px;
    width: 280px;
    height: 100%;
    border: 1px solid #333;
    padding: 36px 0 0 0;
    box-sizing: border-box;
    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 16px;
    }
    .item-number {
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>
